import { render } from "./Login.vue?vue&type=template&id=2f9e87ec&bindings={\"app\":\"props\",\"user\":\"data\",\"logIn\":\"options\"}"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render

export default script